module.exports = __webpack_public_path__ + "img/undraw_verified_re_4io7.256b0bdc.svg";